import { XIcon } from "@heroicons/react/outline";
import { useEffect, useState } from "react";

const Toast = ({ message, type = "error", onClose, duration = 4000 }) => {
  const [progress, setProgress] = useState(100);

  useEffect(() => {
    const start = Date.now();
    const interval = 50; // update every 50ms

    const timer = setInterval(() => {
      const elapsed = Date.now() - start;
      const percentage = Math.max(0, 100 - (elapsed / duration) * 100);
      setProgress(percentage);
    }, interval);

    const timeout = setTimeout(onClose, duration);

    return () => {
      clearInterval(timer);
      clearTimeout(timeout);
    };
  }, [duration, onClose]);

  const colors = {
    error: "bg-red-800",
    success: "bg-green-600",
    info: "bg-slate-700",
  };

  return (
    <div className="w-80 rounded-lg shadow-lg overflow-hidden">
      <div
        className={`px-4 py-3 text-white ${colors[type]} flex justify-between items-start`}
      >
        <div>
          <p className="text-sm">{message}</p>
        </div>

        <button onClick={onClose} className="ml-3 opacity-80 hover:opacity-100">
          <XIcon className="w-4 h-4" />
        </button>
      </div>

      <div className="h-1 bg-black/20">
        <div
          className="h-full bg-white transition-[width]"
          style={{ width: `${progress}%` }}
        />
      </div>
    </div>
  );
};

export default Toast;
